import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from 'styled-components';
import { calculateRem } from '@vds-core/utilities';
import { Body } from '@vds-core/typography';
var InputTextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "InputTextWrapper",
  componentId: "VDS__sc-r9e0ad-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  margin-top: ", ";\n"])), calculateRem(8));
/**
 * @ignore
 */

var InputText = function InputText(_ref) {
  var children = _ref.children,
      fontFamily = _ref.fontFamily,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    role: "alert"
  }, /*#__PURE__*/React.createElement(InputTextWrapper, null, /*#__PURE__*/React.createElement(Body, {
    size: "small",
    fontFamily: fontFamily && fontFamily,
    color: color
  }, children)));
};

export default InputText;